import { render, staticRenderFns } from "./ConfirmClearModal.vue?vue&type=template&id=07b9971e&"
import script from "./ConfirmClearModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmClearModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07b9971e')) {
      api.createRecord('07b9971e', component.options)
    } else {
      api.reload('07b9971e', component.options)
    }
    module.hot.accept("./ConfirmClearModal.vue?vue&type=template&id=07b9971e&", function () {
      api.rerender('07b9971e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/mantap/components/ConfirmClearModal.vue"
export default component.exports